<template>
  <Installation v-slot="{ start }" v-if="showGuideInstall">
    <van-popup
      v-model:show="showGuide"
      position="bottom"
      :lock-scroll="false"
      :close-on-click-overlay="false"
      round
    >
      <div class="guideToInstall">
        <h3 class="tit">{{ $t("home.GuideInstallWithServico.NewVersionTitle") }}</h3>

        <p class="break-words pr-4" v-if="config!.content == 'giveEggs'">
          {{ $t("home.GuideInstallWithServico.AccountRechargeReceived") }}
          <span class="num"
            >R$ {{ formatter().format(config!.presentAmountView || 0) }}</span
          >
        </p>
        <div v-else class="flex-center-col-x text-center">
          <p class="flex items-center">
            <img src="@a/assets/images/i_g.png" class="size-2.5 mr-1" />{{
              $t("home.GuideInstallWithServico.MoreGamesAdded")
            }}
          </p>
          <p class="flex items-center">
            <img src="@a/assets/images/i_g.png" class="size-2.5 mr-1" />{{
              $t("home.GuideInstallWithServico.MoreBonusesDistributed")
            }}
          </p>
          <p class="flex items-start">
            <img src="@a/assets/images/i_g.png" class="size-2.5 mr-1 mt-0.5" />{{
              $t("home.GuideInstallWithServico.SystemInterfaceOptimized")
            }}
          </p>
        </div>

        <div class="w-full flex-center-y mt-6">
          <div
            :class="[
              'primaryBtn !rounded-full mr-4',
              {
                '!bg-[#CEFD55]': isPwaInstalled,
              },
            ]"
            @click="!isPwaInstalled && start()"
          >
            {{ $t("home.GuideInstallWithServico.UpdateNow") }}
          </div>
          <img
            src="@a/assets/images/i_servico.png"
            class="size-11"
            alt=""
            @click="showServico = true"
          />
        </div>

        <div class="warn">
          <img src="@a/assets/images/i_warn.png" class="size-6 mr-1" alt="" />
          {{ $t("home.GuideInstallWithServico.AfterInstallTip") }}
        </div>

        <template v-if="config!.content == 'giveEggs'">
          <div class="mt-4">
            <h4 class="installTip">
              {{ $t("home.GuideInstallWithServico.AndroidInstallTitle") }}
            </h4>
            <p class="leading-[19px]">
              {{ $t("home.GuideInstallWithServico.AndroidInstallSteps") }}
            </p>
          </div>

          <div class="check">
            <img src="@a/assets/images/i_checked.png" class="size-6 mr-1" alt="" />
            <p>{{ $t("home.GuideInstallWithServico.SecurityCertification") }}</p>
          </div>
        </template>

        <span class="closeIcon absolute top-2 right-2" @click="showGuide = false" />
      </div>
    </van-popup>

    <van-popup
      v-model:show="showServico"
      position="bottom"
      :lock-scroll="false"
      :close-on-click-overlay="false"
      round
    >
      <div class="bg-[var(--theme-text-dark)] servicoList">
        <h3 class="tit">{{ $t("home.GuideInstallWithServico.ContactSupport") }}</h3>

        <div class="p-4 pt-3 text-15">
          <h4 class="text-15 font-[600] mb-4">
            {{ $t("home.GuideInstallWithServico.SelectChannel") }}
          </h4>
          <div
            :class="[
              'item',
              {
                '!bg-[var(--input-bg-color)]': selectedId === item.id,
              },
            ]"
            v-for="item in list"
            :key="item.id"
            @click="handleSelector(item.account, item.type, item.id)"
          >
            <Image :src="item.avatar" alt="" class="size-6 mr-2" /><span>{{
              item.name
            }}</span>
          </div>
        </div>
        <span
          class="closeIcon absolute top-3 right-3 !size-6"
          @click="showServico = false"
        />
      </div>
    </van-popup>
  </Installation>
</template>

<script setup lang="ts">
import Installation from "@a/components/Installation/index.vue";
import { isPwaInstalled, isInPWA } from "@/env";
import { useServico } from "@/store";
import { storeToRefs } from "pinia";
import useAPP from "@/hooks/useInstall";
import { formatter } from "@/utils";
import { useUserInfo, useWallet } from "@/store";
// import { useI18n } from 'vue-i18n';
// const { t } = useI18n();

const showGuide = ref(true);
const showServico = ref(false);

const config = computed(() => useAPP().config.value);

const showGuideInstall = ref(false);

const key = "showGuideInstall";
const checkToShowGuideInstall = () => {
  if (!config.value) return;

  if (isInPWA) {
    showGuideInstall.value = false;
    return;
  }

  if (config.value && config.value.install === "Enabled") {
    if (config.value.time === "OnHome") {
      if (config.value.interval == 0) {
        showGuideInstall.value = true;
        showGuide.value = true;
        localStorage.removeItem(key);
        return;
      }

      const t = +localStorage.getItem(key)!;
      const now = Date.now();
      let d = 0;
      if (t) {
        // 不是第一次进来， 检查是否显示引导安装
        const nextTime = t + config.value.interval * 3600 * 1000;
        if (now >= nextTime) {
          localStorage.setItem(key, now + "");
          showGuideInstall.value = true;
          showGuide.value = true;
          d = config.value.interval * 3600 * 1000;
        } else {
          showGuideInstall.value = false;
          showGuide.value = false;
          d = nextTime - now;
        }
      } else {
        // 第一次进来
        localStorage.setItem(key, now + "");
        showGuideInstall.value = true;
        showGuide.value = true;
        d = config.value.interval * 3600 * 1000;
      }

      setTimeout(checkToShowGuideInstall, d);
    } else if (config.value.time === "AfterUserDeposit" && useUserInfo().isLoggedin) {
      if (useWallet().wallet.firstDepositAmount > 0) {
        showGuideInstall.value = true;
        showGuide.value = true;
      }
      localStorage.removeItem(key);
    }
  } else {
    localStorage.removeItem(key);
  }
};

const { list } = storeToRefs(useServico());

const selectedId = ref(0);

const handleSelector = (account, type, id) => {
  selectedId.value = id;

  switch (type) {
    case "Tel":
      window.location.href = `tel:${account}`;
      break;
    case "Whatsapp":
      window.open(`https://wa.me/${account}`, "_blank");
      break;
    case "Instagram":
      window.open(`https://instagram.com/${account}`, "_blank");
      break;
    case "Telegram":
      window.open(`https://t.me/${account}`, "_blank");
      break;
    default:
      window.open(account, "_blank");
      break;
  }
};
</script>

<style lang="scss" scoped>
.guideToInstall {
  @apply text-[var(--theme-text-dark)] w-full pt-[172px] bg-white bg-[url('@a/assets/images/bg_update.png')] bg-no-repeat bg-[length:100%_auto] px-[16px] text-[13px] pb-[16px];

  .tit {
    @apply text-[18px] text-center font-[800] leading-[22px] my-[8px];
  }

  .num {
    @apply text-[var(--theme-primary-hilight)] font-[600] text-[15px] ml-[5px];
  }

  .warn {
    @apply flex bg-[#6453FD1A] rounded-[8px] p-[10px] mt-[12px] text-[var(--theme-primary-hilight)] font-[600];
  }

  .installTip {
    @apply text-[15px] font-[600] mt-[18px] mb-[10px];
  }

  .check {
    @apply flex bg-[#6453FD1A] rounded-[8px] p-[10px] mt-[16px];
  }
}

.servicoList {
  .tit {
    @apply text-[15px] font-[600] h-[44px] bg-[var(--title-bg-color)] text-white text-center leading-[44px];
  }

  .item {
    @apply bg-[#2C795233] rounded-[8px] py-[10px] px-[16px] flex items-center mb-[16px];
  }
}
</style>
